import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Row, Col
} from 'reactstrap';
import classnames from 'classnames';

import { ROUTES } from 'constants/Routes.js';
import { NAVROUTES } from 'constants/NavRoutes.js';

import Reports from 'containers/Reports';
import MeasureOfSuccess from 'components/dashboard/MeasureOfSuccess';
import {
  removeBusinessDetails, removeContactDetails, removeOnboardingStatus
} from '../constants/localStorageManager';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    const { match } = props;
    const { path: currentUrl } = match;

    this.state = {
      activeTab: currentUrl,
    };

    this.toggle = this.toggle.bind(this);
    this.checkTabToggle = this.checkTabToggle.bind(this);
  }

  componentWillMount() {
    this.checkTabToggle();
    this.handleLocalStorage();
  }

  handleLocalStorage = () => {
    removeBusinessDetails();
    removeContactDetails();
    removeOnboardingStatus();
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  checkTabToggle() {
    const { match } = this.props;
    const { path: currentUrl } = match;
    const REPORT_ROUTES = NAVROUTES.REPORT;

    if (ROUTES.DASHBOARD_INDEX.includes(currentUrl)) {
      this.setState({ activeTab: currentUrl });
    } else if (REPORT_ROUTES.includes(currentUrl)) {
      this.setState({ activeTab: '/reports' });
    }
  }

  render() {
    const REPORT_ROUTES = NAVROUTES.REPORT;
    const { match } = this.props;
    const { path: currentPath } = match;

    return (
      <div>
        <div className="below-header pt-3">
          <div className="container">
            <Nav tabs>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={ROUTES.DASHBOARD_INDEX}
                  className={`${classnames({
                    active: ROUTES.DASHBOARD_INDEX === currentPath,
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.DASHBOARD_INDEX);
                  }}
                >
                  Measures of Success
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={ROUTES.REPORT_INDEX}
                  className={`${classnames({
                    active: REPORT_ROUTES.includes(currentPath),
                  })}`}
                  onClick={() => {
                    this.toggle(ROUTES.REPORT_INDEX);
                  }}
                >
                  Survey Reports
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>

        <div className="container">
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId={ROUTES.DASHBOARD_INDEX}>
              <Row>
                <Col sm="12">
                  <MeasureOfSuccess />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={ROUTES.REPORT_INDEX}>
              <Row>
                <Col sm="12">
                  <Reports />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default withRouter(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js